import React from "react";
import "./style.css";
import { Rect1, Rect2, Rect3, Rect4, Rect5, Spinner } from "./styled";

const Loader = ({ color }) => {
  return (
    <Spinner color={color}>
      <Rect1 />
      <Rect2 />
      <Rect3 />
      <Rect4 />
      <Rect5 />
    </Spinner>
  );
};

export default Loader;
